import React, { useCallback, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Box, Divider, Grid } from "@mui/material";
import CarouselGallery from "./components/Carousel";
// import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import ContentGrid from "./components/ContentGrid";
import IntroCard from "./components/IntroCard";
import Recommendation from "./components/Recommendation";
import Album from "./components/Album";
import Process from "./components/Process";
import "./App.css";

import { albumTimGinny } from "./albums/TimGinny";
import { albumWilliamLucaEngagement } from "./albums/WilliamLucaEngagement";
import { albumWilliamLucaWedding } from "./albums/WilliamLucaWedding";
import { albumHerbertHilda } from "./albums/HerbertHilda";
import { albumWilliamMin } from "./albums/WilliamMin";
import { albumMarcoWiola } from "./albums/MarcoWiola";
import { albumTsungChien } from "./albums/TsungChien";
import { albumYuChouYuWen } from "./albums/YuChouYuWen";
import { albumDannyFangJu } from "./albums/DannyFangJu";

export default function App() {
  const initPage = "";
  const [selectedAlbumId, setSelectedAlbumId] = useState(initPage);
  const navigate = useNavigate();
  const location = useLocation();

  // TODO: cleanup
  useEffect(() => {
    if (selectedAlbumId !== "") {
      navigate(`/`);
      setSelectedAlbumId(selectedAlbumId);
    } else {
      navigate(initPage);
      setSelectedAlbumId(initPage);
    }
  }, [selectedAlbumId, navigate]);

  // allow the user to go back to the home page by clicking browser back button
  // TODO: quick fix and temporary implementation. setClickedProjectId state hook might not be needed if using navigate()?
  useEffect(() => {
    // Listen for changes in the URL hash and update the clickedProjectId state.
    const handlePopstate = () => {
      if (location.pathname !== "") {
        setSelectedAlbumId(initPage);
        navigate(initPage);
      }
    };

    window.addEventListener("popstate", handlePopstate);

    // Clean up the event listener when the component unmounts.
    return () => {
      window.removeEventListener("popstate", handlePopstate);
    };
  }, [location.pathname, navigate]);

  const showSelectedAlbum = useCallback(() => {
    switch (selectedAlbumId) {
      case "albumTimGinny": {
        return albumTimGinny;
      }
      case "albumWilliamLucaEngagement": {
        return albumWilliamLucaEngagement;
      }
      case "albumWilliamLucaWedding": {
        return albumWilliamLucaWedding;
      }
      case "albumHerbertHilda": {
        return albumHerbertHilda;
      }
      case "albumWilliamMin": {
        return albumWilliamMin;
      }
      case "albumMarcoWiola": {
        return albumMarcoWiola;
      }
      case "albumTsungChien": {
        return albumTsungChien;
      }
      case "albumYuChouYuWen": {
        return albumYuChouYuWen;
      }
      case "albumDannyFangJu": {
        return albumDannyFangJu;
      }
      default: {
        break;
      }
    }
  }, [selectedAlbumId]);

  const mainPageContent = (
    <>
      <Box width={"85%"}>
        <IntroCard />
        <Divider />
        <ContentGrid setSelectedAlbumId={setSelectedAlbumId} />
        <Recommendation />
        <Divider variant="middle" />
        <Process />
      </Box>
    </>
  );

  return (
    <div>
      <Grid container direction="column" alignItems="center">
        {/* <NavBar /> */}
        <CarouselGallery />
        {selectedAlbumId !== "" ? (
          <Box width={"85%"}>
            <Album album={showSelectedAlbum()} />
          </Box>
        ) : (
          mainPageContent
        )}
      </Grid>
      <Footer />
    </div>
  );
}
